import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IInvitation } from '@app/models/signup';
import { SignupCheckService } from '@app/shared-signup/signup-check.service';

@Component({
  selector: 'signup-landing-buttons',
  templateUrl: './signup-landing-buttons.component.html',
  styleUrls: ['./signup-landing-buttons.component.scss']
})
export class SignupLandingButtonsComponent implements OnInit {
  @Output() landingButtonAction: EventEmitter<string> = new EventEmitter();
  invitation: IInvitation;
  isAutolog: boolean = window['IS_AUTOLOG'];

  @Input() isLoading = false;
  @Input() acceptIsPasswordRestricted = false;
  @Input() removeSidePaddings = false;

  constructor(public checkService: SignupCheckService) {
  }

  ngOnInit() {
    this.invitation = window['INVITATION'];
  }

  createAccount() {
    this.landingButtonAction.emit('createAccount');
  }

  changeAccount() {
    if (window['CURRENT_STATE'] === 'invitation_webmail1') {
      window.location.assign(`/auth/login?project=welcome&uri=${encodeURIComponent('/invitation/webmail1#accept')}`);
    } else {
      this.landingButtonAction.emit('changeAccount');
    }
  }

  login() {
    this.landingButtonAction.emit('login');
  }

  logout() {
    this.landingButtonAction.emit('logout');
  }

  isOtherAccountButtonDisplayed(): boolean {
    return !(this.invitation.type === 'webmail' && this.invitation.extras.ksuite_id) || this.invitation.can_set_email;
  }

  userIsMatching() {
    return window['INVITATION'] && window['CONST_USER'] && window['INVITATION'].user_id === window['CONST_USER'].id;
  }

}
